import { createAction, props } from '@ngrx/store';
import { OidcSignupCompleteRequest } from '@ridango/core';

export const COMPLETE_SIGNUP = '[Auth-Oidc-Signup]: Complete signup';
export const COMPLETE_SIGNUP_SUCCESS = '[Auth-Oidc-Signup]: Complete signup success';
export const COMPLETE_SIGNUP_FAILED = '[Auth-Oidc-Signup]: Complete signup failed';
export const COMPLETE_SIGNUP_RESET = '[Auth-Oidc-Signup]: Complete signup reset';

export const completeSignup = createAction(COMPLETE_SIGNUP, props<{ payload: OidcSignupCompleteRequest }>());
export const completeSignupSuccess = createAction(COMPLETE_SIGNUP_SUCCESS);
export const completeSignupFailed = createAction(COMPLETE_SIGNUP_FAILED, props<{ payload: any }>());
export const completeSignupReset = createAction(COMPLETE_SIGNUP_RESET);
